import {
  DeviceFamily,
  Placement,
  BusinessGroupId,
} from '@amzn/fire-tv-campaign-automation-service';

export type BusinessGroupIdConfig = Record<
  DeviceFamily,
  Partial<Record<Placement, BusinessGroupId[]>>
>;

export const BUSINESS_GROUP_CONFIG: BusinessGroupIdConfig = {
  [DeviceFamily.FIRE_TV]: {
    [Placement.FEATURE_ROTATOR]: [
      BusinessGroupId.Bullseye_Users,
      BusinessGroupId.FTV_Appstore_Marketing,
    ],
    [Placement.SCREEN_SAVER]: [
      BusinessGroupId.Bullseye_Users,
      BusinessGroupId.FTV_Appstore_Marketing,
    ],
  },
  [DeviceFamily.FIRE_TABLETS]: {
    [Placement.FEATURE_ROTATOR]: [BusinessGroupId.GW_DevicesTablet, BusinessGroupId.GW_Appstore],
  },
};
